import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  CircularProgress,
  Box,
  Fade,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useAuth } from "../context/AuthContext";
import IncludedFeaturesImagenes from "../components/IncludedFeaturesImagenes";

export default function LoginPage() {
  const [showFade, setShowFade] = useState(true);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { signin, errors: loginErrors, isAuthenticated, loading } = useAuth();

  const onSubmit = handleSubmit(async (data) => signin(data));

  useEffect(() => {
    if (isAuthenticated) navigate("/");
  }, [isAuthenticated]);

  return (
    <Grid
      container
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #903AF2 0%, #d2c2f2 100%)",
      }}
    >
      {/* Columna del formulario */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 4,
        }}
      >
        <Card
          sx={{
            width: "100%",
            maxWidth: 450,
            bgcolor: "#903AF2",
            color: "#fff",
            borderRadius: 4,
            boxShadow: 8,
          }}
        >
          <CardContent>
            <Typography
              variant="h4"
              fontWeight="bold"
              gutterBottom
              sx={{ textAlign: "center" }}
            >
              Ingresá a tu cuenta
            </Typography>

            <form onSubmit={onSubmit}>
              <TextField
                fullWidth
                margin="normal"
                variant="filled"
                label="Correo electrónico ejemplo@mail.com"
                {...register("email", { required: true })}
                InputProps={{
                  style: {
                    backgroundColor: "#fff",
                    color: "rgba(0, 0, 0, 0.8)",
                  },
                }}
                InputLabelProps={{ style: { color: "rgba(0, 0, 0, 0.65)" } }}
              />
              {errors.email && (
                <Typography color="error">El correo es obligatorio</Typography>
              )}

              <TextField
                fullWidth
                margin="normal"
                variant="filled"
                label="Ingresa tu contraseña"
                type="password"
                {...register("password", { required: true })}
                InputProps={{
                  style: {
                    backgroundColor: "#fff",
                    color: "rgba(0, 0, 0, 0.8)",
                  },
                }}
                InputLabelProps={{ style: { color: "rgba(0, 0, 0, 0.65)" } }}
              />
              {errors.password && (
                <Typography color="error">
                  La contraseña es obligatoria
                </Typography>
              )}

              <Button
                fullWidth
                variant="contained"
                type="submit"
                sx={{
                  mt: 2,
                  bgcolor: "#ee964b",
                  fontSize: "1.1rem",
                  color: "#fff",
                  fontWeight: 700,
                  "&:hover": {
                    bgcolor: "#d0e9b5",
                  },
                }}
              >
                {loading ? (
                  <CircularProgress color="inherit" size={24} />
                ) : (
                  "Iniciar Sesión"
                )}
              </Button>
            </form>

            {loginErrors.map((error, i) => (
              <Typography key={i} color="error" mt={2}>
                {error}
              </Typography>
            ))}

            <Typography textAlign="center" mt={3}>
              ¿Aún no tienes una cuenta?
              <Link
                to="https://wa.me/5492604206967?text=Hola%20quiero%20probar%20Ubika%20por%2014%20días%20gratis"
                target="_blank"
                style={{
                  color: "#f4cca4ff",
                  marginLeft: 5,
                  fontWeight: "bold",
                }}
              >
                Pedí tus 14 días gratis por WhatsApp
              </Link>
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid
        item
        xs={false}
        md={6}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgro:
            "linear-gradient(135deg, #903AF2 40%, #a974eb 80%, #b88ff0 100%)",
          color: "#ECECEC",
          textAlign: "center",
          p: 4,
        }}
      >
        <Box sx={{ width: "100%", maxWidth: 500 }}>
          <IncludedFeaturesImagenes />
        </Box>
      </Grid>

      {/* Fade motivacional */}
      <Fade in={showFade}>
        <Box
          sx={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: "70%", md: "50%" },
            bgcolor: "#fff",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            zIndex: 10,
          }}
        >
          <Typography variant="h6" mb={2}>
            ¿Por qué necesitas registrarte?
          </Typography>
          <Typography>
            Al iniciar sesión o crear una cuenta, podrás acceder a todas
            nuestras funciones y guardar tus preferencias de manera rápida y
            segura.
          </Typography>
          <Button
            variant="contained"
            onClick={() => setShowFade(false)}
            sx={{
              mt: 3,
              mb: 2,
              bgcolor: "#903AF2",
              "&:hover": {
                bgcolor: "#702ac2",
              },
            }}
          >
            Entendido
          </Button>
        </Box>
      </Fade>
    </Grid>
  );
}
